.comment{height:100px;margin-bottom:24px}
/*# sourceMappingURL=users-table.component-FWWTYNNA.css.map */
